module.exports = __webpack_public_path__ + "img/battery-low.339ba578.svg";